module.exports = __webpack_public_path__ + "static/media/carta_89.7c5b54b0.jpg";